import {useHistory} from "react-router-dom";
import {useSelector} from "react-redux";
import {Routes} from "../../../routes";
import React from "react";
import CostosFijosMensual from "../../components/CostosFijos/CostosFijosMensual";

function CostosFijosMensualPage() {
    const navigate = useHistory();
    const ciemId = useSelector(state => state.ciem.ciemId);
    if(!ciemId){
        alert("Para ingresar a esta opcion debe seleccionar una idea de negocio");
        //console.log("no tiene ciem")
        navigate.push(Routes.ListCiemPage.path);
    }
    return (
        <div>
            <CostosFijosMensual ciemId={ciemId}/>
        </div>
    );
}

export default CostosFijosMensualPage;